import { useState } from "react";
import { Menu, X } from "lucide-react";
import { SignInChooser } from "@/components/SignInChooser";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const isHome = window.location.pathname === "/";

  const LINKS = [
    { label: "How it works", href: isHome ? "#how-it-works" : "/#how-it-works" },
    { label: "Products", href: isHome ? "#products" : "/#products" },
    { label: "Pricing", href: "/pricing" },
    { label: "Services", href: "/services" },
    { label: "Contact", href: "/contact" },
    { label: "Sign in", href: "https://wsafeai.com/login" },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-xl border-b border-line">
      <div className="mx-auto max-w-[1160px] px-6 h-16 flex items-center justify-between gap-4">
        <a href="/" data-testid="nav-logo" className="flex items-center gap-2.5 shrink-0">
          <span className="w-3 h-3 bg-safety" />
          <span className="text-base font-extrabold text-navy tracking-tight">WSafe AI</span>
        </a>
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-semibold text-ink hover:text-safety transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3 shrink-0">
          <div className="hidden sm:block">
            <SignInChooser
              testidPrefix="nav-signin"
              buttonClass="rounded-lg border-2 border-navy text-navy text-sm font-bold px-4 py-2 inline-flex items-center gap-1.5 hover:bg-navy hover:text-white transition-colors"
            />
          </div>
          <a
            href="/contact?topic=pilot"
            data-testid="nav-cta-pilot"
            className="rounded-lg bg-safety text-white text-sm font-bold px-4 py-2 hover:bg-[#d97c12] transition-colors"
          >
            Book a pilot
          </a>
          <button
            data-testid="nav-menu-toggle"
            className="lg:hidden text-ink"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-line bg-white px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm font-semibold text-ink"
            >
              {l.label}
            </a>
          ))}
          <SignInChooser
            testidPrefix="mobile-signin"
            buttonClass="rounded-lg border-2 border-navy text-navy text-sm font-bold px-4 py-2 inline-flex items-center gap-1.5"
          />
        </nav>
      )}
    </header>
  );
}
